export default {
  undo({ commit, state, dispatch }) {
    const { action, params } = state.undo[state.undo.length - 1]
    dispatch(action, { ...params, stack: 'redo', stackToClear: '' }, { root: true })
    dispatch('hasUnsaveChanges', true)
    commit('undo')
  },

  redo({ commit, state, dispatch }) {
    const { action, params } = state.redo[state.redo.length - 1]
    dispatch(action, { ...params, stack: 'undo', stackToClear: '' }, { root: true })
    dispatch('hasUnsaveChanges', true)
    commit('redo')
  },

  undoAll({ state, dispatch }) {
    state.undo.forEach(_ => setTimeout(() => dispatch('undo')))
  },

  redoAll({ state, dispatch }) {
    state.redo.forEach(_ => setTimeout(() => dispatch('redo')))
  },

  pushToStack({ commit, dispatch }, { stack, action, params, stackToClear }) {
    if (stackToClear) {
      dispatch('clearStack', stackToClear)
    }
    dispatch('hasUnsaveChanges', true)
    commit('pushToStack', { stack, action, params })
  },

  clearStack({ commit }, stack) {
    commit('clearStack', stack)
  },

  hasUnsaveChanges({ commit }, status) {
    commit('hasUnsaveChanges', status)
  },
}
